import React from 'react';
import { formatWeekHours } from '../utils/utils';

function ItemShops({ shop, index, openQuickContact, cardType, handleShopClick, selectedShop, navigate, openMoreInfo }) {

    const selectedSupplies = Array.isArray(shop?.selectedSupplies)
        ? shop.selectedSupplies
        : [];

    const customSupplies = Array.isArray(shop?.customSupplies)
        ? shop.customSupplies
        : [];


    const fullAddress = shop?.address
        ? `${shop.address.city || ""}, ${shop.address.province || ""}`.replace(", ,", ",")
        : "No Address Provided";


    return (
        <div
            key={index}
            className={`cursor-pointer rounded-[12px] border-2 transition-all overflow-hidden bg-white flex flex-col ${selectedShop && selectedShop.uid === shop.uid ? 'border-[#ff5323] shadow-[0px_2px_16px_0px_rgba(255,83,35,0.15)]' : 'border-[#e4e5e7] hover:border-[#c0c2c6]'} `}
        >
            <div
                onClick={() => cardType === "Marketplace" && handleShopClick(shop)}
            >
                <div
                    className="relative h-[120px] overflow-hidden"
                >
                    <img
                        src={shop?.shopPhoto || `https://images.unsplash.com/photo-1767974785671-cfc4c8727147?crop=entropy&cs=tinysrgb&fit=max&fm=jpg&ixid=M3w3Nzg4Nzd8MHwxfHNlYXJjaHwxfHxwcmludCUyMHNob3AlMjBzdG9yZWZyb250JTIwbW9kZXJufGVufDF8fHx8MTc3MjU2NDg3NHww&ixlib=rb-4.1.0&q=80&w=1080&utm_source=figma&utm_medium=referral`}
                        alt={shop?.shopName || "PrintHub Stellenbosch"}
                        className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-[8px] left-[8px] flex gap-[4px]">
                        {(shop.type === "printShop") && (
                            <span className="bg-[#ff5323] text-white font-semibold text-[10px] px-[8px] py-[3px] rounded-[6px] shadow-[0px_1px_4px_rgba(0,0,0,0.2)]">
                                On-Demand Print
                            </span>
                        )}
                        {(shop.type === "specialist") && (
                            <span className="bg-[#6b5dd3] text-white font-semibold text-[10px] px-[8px] py-[3px] rounded-[6px] shadow-[0px_1px_4px_rgba(0,0,0,0.2)]">
                                Specialist Print
                            </span>
                        )}
                        {(shop.type === "supplier") && (
                            <span className="bg-[#212326] text-white font-semibold text-[10px] px-[8px] py-[3px] rounded-[6px] shadow-[0px_1px_4px_rgba(0,0,0,0.2)]">
                                Supplier
                            </span>
                        )}
                    </div>
                </div>

                <div className="p-[16px] flex flex-col gap-[8px] flex-1">
                    <div className="flex items-center justify-between">
                        <p className="font-['Plus_Jakarta_Sans',sans-serif] font-semibold text-[16px] text-[#212326]">{shop.shopName}</p>
                        {/* <div className="flex items-center gap-[4px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-star w-[14px] h-[14px] fill-[#ff5323] text-[#ff5323]">
                                <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                            </svg>
                            <span className="font-['Plus_Jakarta_Sans',sans-serif] font-medium text-[13px] text-[#53585f]">
                                {shop.reviews !== undefined && shop.reviews !== null && shop.reviews !== ""
                                    ? Number(shop.reviews).toFixed(1)
                                    : "N/A"}
                            </span>
                        </div> */}
                    </div>
                    <div className="flex items-center gap-[6px]">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-map-pin w-[14px] h-[14px] text-[#9298a0] shrink-0">
                            <path d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0"></path>
                            <circle cx="12" cy="10" r="3"></circle>
                        </svg>
                        <p className="font-['Plus_Jakarta_Sans',sans-serif] font-medium text-[13px] text-[#53585f] truncate">
                            {fullAddress}
                        </p>
                    </div>
                    <div className="flex items-center justify-between">
                        <div className="flex items-center gap-[6px]">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-clock w-[14px] h-[14px] text-[#9298a0]">
                                <circle cx="12" cy="12" r="10"></circle>
                                <polyline points="12 6 12 12 16 14"></polyline>
                            </svg>
                            <p className="font-['Plus_Jakarta_Sans',sans-serif] font-semibold text-[12px] text-[#9298a0]">{formatWeekHours(shop?.workingHours)}</p>
                        </div>

                        {/* <span className="font-['Plus_Jakarta_Sans',sans-serif] font-semibold text-[13px] text-[#ff5323]">0.3 km</span> */}
                    </div>
                    <div className="flex flex-wrap gap-[4px] mt-[4px]">
                        {selectedSupplies.slice(0, 2).map((item, i) => (
                            <span key={`s-${i}`} className="bg-[#f4f5f6] px-[8px] py-[2px] rounded-[6px] text-[11px] text-[#53585f]">
                                {item}
                            </span>
                        ))}

                        {customSupplies.slice(0, 1).map((item, i) => (
                            <span key={`c-${i}`} className="bg-[#f4f5f6] px-[8px] py-[2px] rounded-[6px] text-[11px] text-[#53585f]">
                                {item}
                            </span>
                        ))}
                    </div>
                    <p className="font-['Plus_Jakarta_Sans',sans-serif] font-medium text-[12px] text-[#717182] leading-[1.5] mt-[2px] line-clamp-2">
                        {shop.description || "No description provided."}
                    </p>
                    <button
                        onClick={() => { openMoreInfo(shop); }}
                        className="flex items-center gap-[4px] self-start mt-[2px] font-['Plus_Jakarta_Sans',sans-serif] font-semibold text-[12px] text-[#ff5323] hover:underline transition-colors"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-info w-[12px] h-[12px]">
                            <circle cx="12" cy="12" r="10"></circle>
                            <path d="M12 16v-4"></path>
                            <path d="M12 8h.01"></path>
                        </svg>
                        More info
                    </button>
                </div>
            </div>
            <div className="px-[16px] pb-[16px] pt-[4px] flex items-center gap-[8px]">
                {(shop.type === "printShop") &&
                    <button
                        className="flex-1 flex items-center justify-center gap-[6px] h-[38px] rounded-[10px] bg-[#ff5323] text-white font-semibold text-[12px] hover:bg-[#e64a1f] transition-colors"
                        onClick={(e) => {
                            navigate("/marketplace/upload", {
                                state: { selectedShop: shop }
                            });
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-upload w-[14px] h-[14px]">
                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                            <polyline points="17 8 12 3 7 8"></polyline>
                            <line x1="12" x2="12" y1="3" y2="15"></line>
                        </svg>
                        Send Files
                    </button>
                }

                {(shop.type === "supplier" || shop.type === "specialist" || shop.type === "printShop") &&
                    <button
                        className="flex-1 flex items-center justify-center gap-[6px] h-[38px] rounded-[10px] border border-[#e4e5e7] text-[#212326] font-semibold text-[12px] hover:bg-[#f4f5f6] transition-colors"
                        onClick={(e) => {
                            e.stopPropagation();
                            openQuickContact(shop)
                        }}
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-message-circle w-[14px] h-[14px]">
                            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                        </svg>
                        Quick Contact
                    </button>
                }
            </div>
        </div>
    );
}

export default ItemShops;